export enum ECustomerOrganizationStatus {
  Default = 0,
  New = 1,
  Active = 2,
  Inactive = 3,
}

export enum ECustomerStatus {
  New = 1,
  Verified = 2,
  Deleted = 3,
}

export enum ECustomerUpdateStatus {
  Success = 'Success',
  Failure = 'Failure',
  Default = 'Default',
}
